import AuthenticationFields from './AuthenticationFields';

export default AuthenticationFields;
